/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box } from '@chakra-ui/react';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { NewTotalValues } from 'models/response/blockOutput.interface';
import { getBlocks } from 'redux/DashboardSlice';

import ExportTable from './ExportTable';
import { BaseInstrumentProperties } from './proptypes';

export const TableInstrument = ({ widget, output }: BaseInstrumentProperties) => {
  const model = useSelector(getBlocks);
  const [widgetData, setWidgetData] = useState<any>(null);
  const [tableData, setTableData] = useState<Array<any> | null>(null);
  const [tableHeaderData, setTableHeaderData] = useState<Array<any> | null>(null);
  const timeGranularity =
    widget?.time_granularity === 'month' ? 'M' : widget?.time_granularity === 'quarter' ? 'Q' : 'Y';

  const expandKey = widget?.expandKey || null;
  const fiscalYearMapping = output?.time_granularity || {};
  const formatTableData = () => {
    if (widgetData) {
      const indicatorTableOutput = JSON.parse(JSON.stringify(widgetData));

      let keysToAdd: string[] = [];
      if (indicatorTableOutput && indicatorTableOutput.length > 0) {
        if (expandKey) {
          if (timeGranularity === 'Y') {
            const year = expandKey;
            for (let index = 0; index < Object.values(fiscalYearMapping[year]).length; index += 1) {
              const quarter: any = Object.values(fiscalYearMapping[year])[index];
              keysToAdd = keysToAdd.concat(quarter);
            }
          } else if (timeGranularity === 'Q') {
            const year = expandKey.split('-')[1];
            const quarter: string = expandKey;

            keysToAdd = fiscalYearMapping[year][quarter].map((month: string) => {
              return `${month}`;
            });
          }
        }
        const tableDataArray = [];
        for (let index = 0; index < indicatorTableOutput?.length; index += 1) {
          const data = indicatorTableOutput[index];

          let filteredKeys: any = [];
          if (data?.dim_df && data?.dim_df.length > 0) {
            const items = (data.dim_df as NewTotalValues[]).map((item: any) => {
              if (data?.dim_df) {
                const itemKeys = (item.values as NewTotalValues[])?.map((subItem: any) => {
                  let isShow = false;
                  let isExpandedColumn = false;
                  if (timeGranularity === 'Q' && subItem.Time[0] === 'Q') {
                    isShow = true;
                  } else if (timeGranularity === 'Y' && subItem.Time.length === 4) {
                    isShow = true;
                  } else if (subItem.Time.length === 6 && timeGranularity === 'M') {
                    isShow = true;
                  } else {
                    const check = keysToAdd.includes(subItem.Time);
                    isShow = keysToAdd && keysToAdd.length > 0 && check;
                    if (isShow) isExpandedColumn = true;
                  }

                  Object.assign(subItem, { isShow, isExpandedColumn });

                  return subItem;
                });
                data.value = itemKeys;
              }
              return item;
            });

            data.dim_df = items;
          }
          const timeAggregation = model?.time_properties?.time_granularity
            ? (model?.time_properties?.time_granularity as string).toUpperCase()
            : 'M';
          if (data?.total && data?.total.length) {
            filteredKeys = (data.total as NewTotalValues[]).map((item: any) => {
              let isShow = false;
              let isExpandedColumn = false;
              let isShowExpandable = false;
              if (timeGranularity === 'Q' && item.Time[0] === 'Q') {
                isShow = true;
                isShowExpandable = true;
              } else if (timeGranularity === 'Y' && item.Time.length === 4) {
                isShow = true;
                isShowExpandable = true;
              } else if (item.Time.length === 6 && timeGranularity === 'M') {
                isShow = true;
              } else {
                const check = keysToAdd.includes(item.Time);
                isShow = keysToAdd && keysToAdd.length > 0 && check;
                if (isShow) isExpandedColumn = true;
              }

              if (timeAggregation === 'Y') isShowExpandable = false;

              Object.assign(item, { isShow, isShowExpandable, isExpandedColumn });
              return item;
            });
          }

          data.total = filteredKeys;
          if (index === 0) {
            setTableHeaderData(filteredKeys);
          }

          tableDataArray.push(data);
        }
        setTableData(tableDataArray);
      } else {
        setTableData(null);
        setTableHeaderData(null);
      }
    }
  };

  useEffect(() => {
    const value = output?.data;
    if (value) {
      setWidgetData(value);
    }
  }, [widget, output]);

  useEffect(() => {
    if (widgetData && timeGranularity) {
      formatTableData();
    }
  }, [widgetData, timeGranularity, expandKey]);

  const isDimensionFilter = useMemo(() => {
    const indicatorsWithDimensions = widget?.instrument_indicators?.filter((indicator: any) => {
      return (
        indicator?.formatting &&
        Array.isArray(indicator?.formatting?.dimensionItems) &&
        indicator?.formatting?.dimensionItems?.length > 1 &&
        indicator?.dimension_id !== null &&
        indicator?.dimension_id !== ''
      );
    });

    if (!indicatorsWithDimensions?.length) return false;

    const firstDimensionId: any = indicatorsWithDimensions[0]?.dimension_id;
    const allSameDimension = indicatorsWithDimensions.every(
      (indicator: any) => indicator?.dimension_id === firstDimensionId,
    );

    const actualIndicators = widget?.instrument_indicators.filter(
      (indicator: any) => indicator.indicator_id,
    );

    const eachIndicatorHasSameDimension = actualIndicators.every(
      (indicator: any) => indicator?.dimension_id === firstDimensionId,
    );
    return (allSameDimension && eachIndicatorHasSameDimension) || false;
  }, [widget?.instrument_indicators?.length, widget?.instrument_indicators]);
  const tableFormattedData = {
    tableData,
    timeGranularity,
    expandkey: widget?.expandKey,
    tableHeaderData,
    isDashboardLayout: true,
    isDimensionFilter,
    output: widget,
  };
  return (
    <Box height='100%' width='100%'>
      <ExportTable {...tableFormattedData} />
    </Box>
  );
};
export default TableInstrument;
